<template>
  <div class="faq-section">
    <div class="faq-section__title" v-if="title && title.length">{{ title }}</div>
    <div class="faq-section__content">
      <div v-for="(question, index) in questions" :key="index" class="faq-section-item">
        <div
          :class="[
            'faq-section-item__question',
            'font-semibold cursor-pointer select-none',
            isOpen(index) && 'faq-section-item__question--open',
          ]"
          @click="toggle($event, index)"
        >
          <i :class="['mr-1 fas fa-caret-right', isOpen(index) && 'rotate-90']"/>
          {{ question.question }}
        </div>
        <div
          :class="['faq-section-item__answer text-justify', isOpen(index) && 'faq-section-item__answer--open']"
          ref="answers"
          :style="getAnswerStyle(index)"
        >
          <p v-html="question.answer"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

export default {
  props: {
    questions: Array,
    title: String,
    padding: Number,
  },

  data() {
    return {
      openedIndex: null,
    };
  },

  methods: {
    toggle(event, index) {
      this.openedIndex = this.isOpen(index) ? null : index;
    },

    isOpen(index) {
      return this.openedIndex === index;
    },

    getAnswerStyle(index) {
      const el = get(this.$refs, ['answers', index]);

      // If it's the opened item, it's max-height is its height
      if (el && this.isOpen(index)) {
        return {
          maxHeight: `${el.scrollHeight + this.padding}px`,
        };
      }

      // Else the answer shouldn't be visible
      return { maxHeight: 0 };
    },
  },
};
</script>

<style lang="scss" scoped>
$duration: 0.25s;

.faq-section {
  @apply mb-8;

  i.fas {
    transition: transform $duration, color $duration;
  }

  .faq-section-item__answer {
    overflow: hidden;
    font-size: 14px;
    opacity: 0.8;
    transition: max-height $duration, padding-top $duration,
      padding-bottom $duration;

    p {
      transition: opacity $duration;
      opacity: 0;
    }

    &--open {
      p {
        opacity: 1;
      }
    }
  }
}

.rotate-90 {
  transform: rotate(90deg);
}
</style>
